import classNames from 'classnames';
import { FC, ReactNode, useEffect } from 'react';

interface Props {
  value: any;
  activeValue?: any;
  children: ReactNode | string;
  onChange?: (value: string) => void;
}
const Option: FC<Props> = ({ value, activeValue, children, onChange }) => {
  useEffect(() => {
    if (activeValue === value) {
      onChange?.(value);
    }
  }, []);

  return (
    <li
      onClick={() => onChange?.(value)}
      className={classNames('w-full cursor-pointer px-[16px] py-[8px] hover:bg-[#F8F9FF] lg:px-[24px] lg:py-[10px]', {
        'bg-[#F8F9FF]': activeValue === value,
      })}
    >
      {children}
    </li>
  );
};

export default Option;
